import { setAppErrors } from '../../../action/system'
import { retrieveErrorFromApi } from '../../../../helper'
import fetchTableOrders from '../../../axios/restaurant/table/order'
import { setTableCartLoading, setTableCartOrders } from '../../../action/tableCart'
import closeTableOrders from '../../../axios/restaurant/table/order/closeOrders/post'
import printTableOrders from '../../../axios/restaurant/table/order/printOrders/post'
import { fetchRestaurantTablesThunk, fetchRestaurantTableThunk } from '../table'
import { setRestaurantAbortOrderModal, setRestaurantOrderPublicId, setRestaurantProcessPaymentErrorModalData, setRestaurantShowProcessPaymentErrorModal, setRestaurantTableClosedErrorModal } from '../../../action/restaurant'
import { fetchPrintSettingsThunk } from '../../printReceipt'
import moveOrderToKitchen from '../../../axios/restaurant/table/order/moveToKitchen/put'
import updateOrderItemStatus from '../../../axios/restaurant/table/order/status/put'
import updateWaiterNotificationStatus from '../../../axios/restaurant/table/order/waiterNotificationStatus/put'
import closePaidBeforeOrders from '../../../axios/restaurant/table/order/closePaidBeforeOrders/post'
import getOrder from '../../../axios/orderview/get'
import { fetchTableSplitsThunk } from '../split'
import { logger } from '../../../../logger/logger'
import updateTableCart from '../../../axios/restaurant/table/order/updateCart/post'
import updateTableCartForAdmin from '../../../axios/restaurant/table/order/updateCartForAdmin/post'
import abortTableOrders from '../../../axios/restaurant/table/order/abortOrders/post'
import { setRoomChargeOrderId } from '../../../action/roomCharge'
import { ROOM_CHARGE_PAYMENT_METHOD } from '../../../../component/RoomCharge/constants'

export const fetchTableOrdersThunk = (tableId, ungroup, status) => dispatch => {
	return fetchTableOrders(tableId, ungroup, status)
		.then(res => {
			if (res.data) {
				return dispatch(setTableCartOrders(res.data))
			}
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const closeTableOrdersThunk = (tableId, data, hasModalLogin) => async (dispatch, getState) => {
	try {
		const isEcTerminalPaymentMethod = data.paymentMethod === 'EC_TERMINAL'
		const isTap2PayPaymentMethod = data.paymentMethod === 'TAP_TO_PAY'
		const isRoomChargePaymentMethod = data.paymentMethod === ROOM_CHARGE_PAYMENT_METHOD
		const res = await closeTableOrders(tableId, data, hasModalLogin)
		if (!isEcTerminalPaymentMethod && !isTap2PayPaymentMethod && !isRoomChargePaymentMethod) {
			dispatch(fetchPrintSettingsThunk(res.data.orderId, { module: 'RESTAURANT', businessScope: 'RESTAURANT' }))
		}
		if (isRoomChargePaymentMethod) {
			dispatch(setRoomChargeOrderId(res.data.orderId))
		}
		dispatch(setRestaurantOrderPublicId(res.data?.publicId))
		return res.data.orderId
	} catch (error) {
		const errorStatusCode = error.response.data?.apierror.errorStatusCode
		if (errorStatusCode === 'terminal_payment_session_invalid') {
			const paymentEC = data.payments.find(payment => payment.method === 'EC_TERMINAL')
			logger.error(`Close table order: paymentId=${data.paymentId} totalPrice=${paymentEC?.total} companyIndex=${getState().login.companyIndex}`)
		} else if (errorStatusCode === 'table_order_is_not_exist') {
			dispatch(setRestaurantTableClosedErrorModal(true))
			return null
		} else if (errorStatusCode === 'order_is_being_paid') {
			dispatch(setRestaurantProcessPaymentErrorModalData({ ...error.response.data?.apierror.data }))
			dispatch(setRestaurantShowProcessPaymentErrorModal(true))
			return null
		}
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
		throw new Error(error.response.data?.apierror?.message)
	}
}

export const printTableOrdersThunk = (tableId, data) => dispatch => {
	return printTableOrders(tableId, data)
		.then(res => {
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const moveTableOrderToKitchenThunk = (tableId, data, hasModalLogin) => (dispatch, getState) => {
	return moveOrderToKitchen(tableId, data, hasModalLogin)
		.then(res => {
			return dispatch(fetchRestaurantTablesThunk(getState().restaurant.areaId))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateTableOrderItemStatusThunk = (tableId, orderId, itemPositionId, status, hasModalLogin) => async (dispatch) => {
	try {
		await updateOrderItemStatus(tableId, orderId, itemPositionId, status, hasModalLogin)
		dispatch(fetchTableOrdersThunk(tableId))
		dispatch(fetchTableSplitsThunk(tableId))
		return dispatch(fetchRestaurantTableThunk(tableId))
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const updateTableWaiterNotificationStatusThunk = (tableId, data, hasModalLogin) => (dispatch, getState) => {
	return updateWaiterNotificationStatus(tableId, data, hasModalLogin)
		.then(res => {
			return dispatch(fetchRestaurantTablesThunk(getState().restaurant.areaId))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const closeTablePaidBeforeOrdersThunk = (tableId, hasModalLogin) => async (dispatch, getState) => {
	try {
		await closePaidBeforeOrders(tableId, hasModalLogin)
		return dispatch(fetchRestaurantTablesThunk(getState().restaurant.areaId))
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const getRestaurantOrderThunk = (orderId) => async (dispatch) => {
	try {
		const res = await getOrder(orderId)
		return res.data
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const updateTableCartThunk = (tableId, data, hasModalLogin, accessToken, hasAdminToken, callbackSuccess) => async (dispatch, getState) => {
	dispatch(setTableCartLoading(true))
	try {
		logger.info(`Update table cart: tableId=${tableId} totalPrice=${data?.totalPrice}`)
		hasAdminToken  ? await updateTableCartForAdmin(tableId, data, accessToken) : await updateTableCart(tableId, data, hasModalLogin)
		if (typeof callbackSuccess === 'function') {
			callbackSuccess()
		}
		return dispatch(fetchRestaurantTablesThunk(getState().restaurant.table.areaId))
	} catch (error) {
		const responseData = error?.response?.data
		const errorStatusCode = responseData?.apierror.errorStatusCode
		if (errorStatusCode === 'order_is_being_paid') {
			dispatch(setRestaurantProcessPaymentErrorModalData({ ...error.response.data?.apierror.data }))
			return dispatch(setRestaurantShowProcessPaymentErrorModal(true))
		} else if (responseData?.apierror?.status !== 'NOT_FOUND') {
			return dispatch(setAppErrors(retrieveErrorFromApi(error)))
		} else {
			logger.warn('Table updateTableCart warn')
			return dispatch(fetchTableOrdersThunk(tableId))
		}
	} finally {
		dispatch(setTableCartLoading(false))
	}
}

export const abortTableOrdersThunk = (tableId, reason, reasonCode, hasModalLogin) => dispatch => {
	return abortTableOrders(tableId, { reason, reasonCode }, hasModalLogin)
		.then(() => {
			dispatch(setRestaurantAbortOrderModal(false))
			return { success: true }
		}).catch(error => {	
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
